<script lang="ts" module>
	export const symbolId = "ishavskraft-icon-check-outline";
	export const symbol = `
		<symbol id="${symbolId}" viewBox="0 0 45 45" xmlns="http://www.w3.org/2000/svg">
			<path
				d="M19.875 25.875L15.7969 21.7969C15.4531 21.4531 15.0231 21.2888 14.5069 21.3038C13.9906 21.3188 13.5613 21.4987 13.2188 21.8438C12.875 22.1875 12.7031 22.625 12.7031 23.1562C12.7031 23.6875 12.875 24.125 13.2188 24.4688L18.5625 29.8125C18.9062 30.1562 19.3438 30.3281 19.875 30.3281C20.4062 30.3281 20.8438 30.1562 21.1875 29.8125L31.8281 19.1719C32.1719 18.8281 32.3363 18.3981 32.3213 17.8819C32.3063 17.3656 32.1263 16.9363 31.7813 16.5938C31.4375 16.25 31 16.0781 30.4688 16.0781C29.9375 16.0781 29.5 16.25 29.1562 16.5938L19.875 25.875ZM22.5 41.25C19.9062 41.25 17.4688 40.7575 15.1875 39.7725C12.9063 38.7875 10.9219 37.4519 9.23438 35.7656C7.54688 34.0781 6.21125 32.0938 5.2275 29.8125C4.24375 27.5312 3.75125 25.0938 3.75 22.5C3.75 19.9062 4.2425 17.4688 5.2275 15.1875C6.2125 12.9063 7.54813 10.9219 9.23438 9.23438C10.9219 7.54688 12.9063 6.21125 15.1875 5.2275C17.4688 4.24375 19.9062 3.75125 22.5 3.75C25.0938 3.75 27.5312 4.2425 29.8125 5.2275C32.0938 6.2125 34.0781 7.54813 35.7656 9.23438C37.4531 10.9219 38.7894 12.9063 39.7744 15.1875C40.7594 17.4688 41.2513 19.9062 41.25 22.5C41.25 25.0938 40.7575 27.5312 39.7725 29.8125C38.7875 32.0938 37.4519 34.0781 35.7656 35.7656C34.0781 37.4531 32.0938 38.7894 29.8125 39.7744C27.5312 40.7594 25.0938 41.2513 22.5 41.25ZM22.5 37.5C26.6562 37.5 30.1956 36.0394 33.1181 33.1181C36.0406 30.1969 37.5013 26.6575 37.5 22.5C37.5 18.3438 36.0394 14.8044 33.1181 11.8819C30.1969 8.95937 26.6575 7.49875 22.5 7.5C18.3438 7.5 14.8044 8.96062 11.8819 11.8819C8.95937 14.8031 7.49875 18.3425 7.5 22.5C7.5 26.6562 8.96062 30.1956 11.8819 33.1181C14.8031 36.0406 18.3425 37.5013 22.5 37.5Z"
				fill="currentColor"
			/>
		</symbol>`;
</script>

<script lang="ts">
	import type { ClassValue } from "svelte/elements";

	let {
		class: classes = null,
		ariaHidden = true,
	}: {
		class?: ClassValue | null;
		ariaHidden?: boolean;
	} = $props();
</script>

<svg
	aria-hidden={ariaHidden}
	width="24"
	height="24"
	viewBox="0 0 45 45"
	fill="none"
	xmlns="http://www.w3.org/2000/svg"
	class={classes}
>
	<use href="#{symbolId}" />
</svg>
